<div class="col-12 heading">
    <p>Events</p>
</div>
<div class="calendar-container">
    <button (click)="prevWeek()" class="nav-button">&lt;</button>
    <div class="week">
        <div *ngFor="let day of currentWeek" class="day" [class.selected]="selectedDate === day.date()"
            (click)="selectDate(day.date())">
            <div class="day-name">{{ day.format('dd').charAt(0) }}</div>
            <div class="day-number">{{ day.date() }}</div>
        </div>
    </div>
    <button (click)="nextWeek()" class="nav-button">&gt;</button>
</div>
<p-divider></p-divider>
<!-- <div class="row">
    <div class="col-sm-2" class="date-section">
        <p class="month">Dec</p>
        <p class="date">20</p>
    </div>
     <div class="col-sm-1">
        <p-divider layout="vertical"></p-divider>
    </div>
    <div class="col-sm-9" class="data-section">
        <p class="data">Thanksgiving Party</p>
    </div>
</div> -->